<template>
  <v-container fluid>
      <v-tabs v-model="activeTab" fixed-tabs>
        <v-tab>My Races</v-tab>
        <v-tab>My Time Trials</v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab" touchless>
        <v-tab-item><ChallengeList challenge-type="RACE" show-finished @noItems="activeTab=2"/></v-tab-item>
        <v-tab-item><ChallengeList challenge-type="TIME_TRIAL" show-finished/></v-tab-item>
      </v-tabs-items>
  </v-container>
</template>

<script>
import ChallengeList from '../components/ChallengeList';

export default {
  name: 'HistoryView',
  components: {
    ChallengeList
  },
  data: () => ({
    activeTab: 0
  })
};
</script>

<style scoped>

</style>